import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Alert,
  CircularProgress,
  Stack,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  CheckCircle,
  Error,
  AccessTime,
  Receipt,
  Home,
  ShoppingCart,
  Payment,
  Refresh,
  PendingActions,
  SmsFailed,
  Download,
} from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { orderService } from '../../services/orderService';
import { restaurantService } from '../../services/restaurantService';
import CommonModal from '../../components/common/CommonModal';
import urlUtils from '../../utils/urlUtils';
import {downloadInvoicePDF} from '../../services/invoiceService_new';
import { useNotification } from '../../contexts/NotificationContext';
import { publicOrderStatusUpdate } from '../../services/publicOrderStatusService';
import {saveSessionID} from '../../services/feedBackService';
import colors from '../../components/colors';


const PaymentResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { clearCart, loadRestaurantData , selectedOutlet} = useRestaurant();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {showSuccess, ShowError} = useNotification()
  const [paymentStatus, setPaymentStatus] = useState('success');
  const [onlinePayOrder, setOnlinePayOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkingPayment, setCheckingPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentCheckCount, setPaymentCheckCount] = useState(0);
  const [restaurantData, setRestaurantData] = useState({});
  const [modalOpen, setModalOpen] = useState(false)
  const maxPaymentChecks = 10;


  // console.log("Selected Outlet => ", selectedOutlet)
  // Function to check payment status
  const checkPaymentStatus = async (orderId) => {
    if (!orderId || paymentCheckCount >= maxPaymentChecks) return;

    setCheckingPayment(true);
    try {
      const paymentData = await orderService.getPaymentStatus(orderId);
      // console.log('Payment status check:', paymentData);

      if (paymentData.payment_status === 'paid' && paymentData.has_payment_record) {
        setPaymentStatus('success');
        setOrderDetails(prev => ({
          ...prev,
          payment_status: 'paid',
          payment_record: paymentData.payment_record
        }));
        setCheckingPayment(false);

        // Call confirm payment API to ensure payment data is saved
        try {
          const confirmData = {
            provider_payment_id: paymentData.payment_record?.provider_payment_id || `webhook_${orderId}_${Date.now()}`,
            payment_method: 'pay_online',
            amount: paymentData.payment_record?.amount || 0,
            currency: 'SGD',
            payment_metadata: {
              order_id: orderId,
              order_number: paymentData.order_number,
              payment_type: 'webhook_confirmed',
              confirmed_at: new Date().toISOString(),
              webhook_data: paymentData.payment_record
            }
          };

          await orderService.confirmPayment(orderId, confirmData);
          // console.log('Payment confirmed via API after webhook');
        } catch (error) {
          console.error('Failed to confirm payment via API:', error);
        }

        return true;
      } else if (paymentData.payment_status === 'failed') {
        setPaymentStatus('failed');
        setCheckingPayment(false);
        return true;
      }

      setPaymentCheckCount(prev => prev + 1);
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentCheckCount(prev => prev + 1);
    } finally {
      setCheckingPayment(false);
    }
    return false;
  };


  // useEffect(()=>{
  //   let status = searchParams.get('status') || location.state?.status ;
  //    let order = location.state?.order;
  //   async function saveSessionData(payload){
  //     try{
  //       const response = await saveSessionID(payload); 
  //     }
  //     catch(error){
  //       console.error("Error => ", error)
  //     }
    
  //   }

  //   if (status === 'success') {
    
  //     let guest_id = localStorage.getItem("device_uuid");
  //     let payload = {
  //       "guest_id":guest_id,
  //       "order_id":order?.id
  //     }
  //     saveSessionData(payload)
  //   }
  // },[])

  useEffect(() => {
    let status = searchParams.get('status') || location.state?.status ;
    // console.log("Status => ", status);
    if (searchParams.get('status') === 'completed') status = 'success';
    // let order = location.state?.order;
    let order = JSON.parse(sessionStorage.getItem("pendingOrder"))
    // console.log("Order details => ", order);
    let p = location.state?.order?.payment_method;
    setPaymentMethod(p);

    async function updateStatus(order_id,status_val){
      let status = {
        "status":"failed"
      }
      try{
        const response = await publicOrderStatusUpdate(order_id,status)
        // console.log("Response => ", response)
        // if(response.status === "200"){
        //   clearCart()
        //   sessionStorage.removeItem("pendingOrder")
        // }
        

      }
      catch(error){
        console.error("Error Happened on Update Status")
      }
    }

    if(status === "canceled"){
      let order = JSON.parse(sessionStorage.getItem("pendingOrder"))
      // console.log("Order in IF => ", order)
      updateStatus(order.id,"failed")
    }

    try {
      async function fetchRestaurantData() {
        const response = await restaurantService.getPublicRestaurantData();
        setRestaurantData(response);
      }
      fetchRestaurantData();
    } catch (error) {
      console.error("Error on Getting Restaurant Data => ", error);
    }

    const isMockPayment = searchParams.get('mock') === 'true';

    if (!order && status === 'success') {
      const pendingOrder = sessionStorage.getItem('pendingOrder');
      if (pendingOrder) {
        try {
          order = JSON.parse(pendingOrder);
          setOnlinePayOrder(order);
          sessionStorage.removeItem('pendingOrder');
        } catch (error) {
          console.error('Error parsing pending order:', error);
        }
      }
    }

    setPaymentStatus(status);
    setOrderDetails(order);

    const orderId = searchParams.get('order_id') || order?.id;
    if (orderId && !isMockPayment && status === 'success') {
      // console.log('Payment status polling temporarily disabled to prevent repeated API calls');
    }

  
    if (status === 'success') {
      clearCart && clearCart();
    }

    setLoading(false);
  }, [searchParams, location.state, clearCart]);

  const getStatusIcon = () => {
    if (checkingPayment) {
      return (
        <CircularProgress
          size={40}
          sx={{
            color: "#FF7900",
            animation: "pulse 2s ease-in-out infinite"
          }}
        />
      );
    }

    switch (paymentStatus) {
      case 'success':
        return <CheckCircle sx={{ color: "#23A26D", fontSize: 40 }} />;
      case 'pending':
        return <PendingActions sx={{ color: "#FF7900", fontSize: 40 }} />;
      case 'failed':
        return <SmsFailed sx={{ color: "#D32F2F", fontSize: 40 }} />;
      default:
        return <Receipt sx={{ color: "#23A26D", fontSize: 40 }} />;
    }
  };

  const getStatusTitle = () => {
    if (checkingPayment) {
      return "Verifying Payment...";
    }

    switch (paymentStatus) {
      case 'success':
        return paymentMethod === "cash_on_delivery" ? "Order Placed Successfully!" : 'Order Placed and Your Payment Was Successful!';
      case 'pending':
        return paymentMethod === "cash_on_delivery" ? "Order Processing" : 'Payment Pending But Order Placed Successfully';
      case 'failed':
        return paymentMethod === "cash_on_delivery" ? "Order Failed" : 'Payment Failed';
      default:
        return 'Order is Cancelled';
    }
  };

  const getStatusColor = () => {
    if (checkingPayment) {
      return "#FF7900";
    }

    switch (paymentStatus) {
      case 'success':
        return "#23A26D";
      case 'pending':
        return "#FF7900";
      case 'failed':
        return "#D32F2F";
      default:
        return "#23A26D";
    }
  };

  const getStatusMessage = () => {
    if (checkingPayment) {
      return 'We are verifying your payment with our payment provider. This usually takes a few moments. Please wait...';
    }

    switch (paymentStatus) {
      case 'success':
        return paymentMethod === "cash_on_delivery"
          ? "Thank you for your order! Your order has been confirmed and is being processed. You will receive an order confirmation shortly."
          : 'Thank you for your payment! Your order has been confirmed and is being processed. You will receive an order confirmation shortly.';
      case 'pending':
        return paymentMethod === "cash_on_delivery"
          ? "Your order is being processed. You will receive a confirmation once it's completed."
          : 'Your payment is being processed. This may take a few moments. You will receive a confirmation once completed.';
      case 'failed':
        return paymentMethod === "cash_on_delivery"
          ? "We encountered an issue processing your order. Please try again or contact our support team for assistance."
          : 'We encountered an issue processing your payment. Please try again or use a different payment method.';
      default:
        return 'if any queries please contact our Restaurant Team.';
    }
  };

  const getButtonColor = () => {
    return colors.primary.main;
  };

  const getButtonHoverColor = () => {
    return colors.secondary.main;
  };

  const handleDownloadInvoice = async () => {
    try{
      const response = await downloadInvoicePDF(orderDetails?.unique_string);
    }
    catch(error){
      console.error("Error on Downloading PDF ", error)
    }
  }

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#FFFFFF'
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Processing Payment...</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
          .poppins-text {
            font-family: 'Poppins', sans-serif;
          }
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.05); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>

      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width="100%"
        backgroundColor="#FFFFFF"
        minHeight="100vh"
        py={4}
        sx={{ mt: 10 }}
      >
        <Paper
          sx={{
            mt: 8,
            background: "#ffffff",
            borderRadius: "12px",
            width: { xs: "90%", sm: "450px" },
            py: "30px",
            px: "25px",
            boxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.05)"
          }}
        >
          {/* Status Icon */}
          <Box width="100%" display={"flex"} justifyContent={"center"} mb={3}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: checkingPayment
                  ? "rgba(255, 121, 0, 0.08)"
                  : paymentStatus === 'success'
                    ? "rgba(35, 162, 109, 0.08)"
                    : paymentStatus === 'pending'
                      ? "rgba(255, 121, 0, 0.08)"
                      : "rgba(211, 47, 47, 0.08)",
              }}
            >
              <Box
                sx={{ width: "70px", height: "70px" }}
                display="flex"
                justifyContent={"center"}
                alignItems={"center"}
              >
                {getStatusIcon()}
              </Box>
            </Box>
          </Box>

          {/* Status Title and Amount */}
          <Stack gap={"8px"} sx={{ py: "15px" }} alignItems={"center"}>
            <Typography
              className="poppins-text"
              sx={{
                color: "#2D2D2D",
                fontWeight: "600",
                fontSize: "20px !important",
                textAlign: "center",
                lineHeight: 1.3
              }}
            >
              {getStatusTitle()}
            </Typography>

            {orderDetails?.total_amount && (
              <Typography
                className="poppins-text"
                sx={{
                  color: "#2D2D2D",
                  fontWeight: "700",
                  fontSize: "28px !important",
                }}
              >
                S$ {orderDetails.total_amount?.toFixed(2)}
              </Typography>
            )}
          </Stack>

          {/* Status Message */}
          <Typography
            className="poppins-text"
            sx={{
              color: "#666666",
              fontWeight: "400",
              fontSize: "14px",
              textAlign: "center",
              mb: 4,
              lineHeight: 1.6
            }}
          >
            {getStatusMessage()}
          </Typography>

          {/* Order Details */}
          {orderDetails && (
            <>
              <Box sx={{
                backgroundColor: "#F8F9FA",
                borderRadius: "8px",
                p: 3,
                mb: 3
              }}>
                <Typography
                  className="poppins-text"
                  sx={{
                    color: "#2D2D2D",
                    fontWeight: "600",
                    fontSize: "16px",
                    mb: 2
                  }}
                >
                  Order Summary
                </Typography>

                <Stack gap="12px">
                  <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#666666",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Order Number
                    </Typography>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#2D2D2D",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      {orderDetails.order_number}
                    </Typography>
                  </Stack>

                  {/* <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#666666",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Customer Name
                    </Typography>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#2D2D2D",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      {orderDetails.customer_name || 'Guest Customer'}
                    </Typography>
                  </Stack> */}

                  <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#666666",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Order Type
                    </Typography>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#2D2D2D",
                        fontWeight: "600",
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                    >
                      {orderDetails.order_type}
                    </Typography>
                  </Stack>

                  {orderDetails.delivery_address && (
                    <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                      <Typography
                        className="poppins-text"
                        sx={{
                          color: "#666666",
                          fontWeight: "400",
                          fontSize: "14px",
                        }}
                      >
                        Delivery Address
                      </Typography>
                      <Typography
                        className="poppins-text"
                        sx={{
                          color: "#2D2D2D",
                          fontWeight: "600",
                          fontSize: "14px",
                          textAlign: 'right',
                          maxWidth: '150px'
                        }}
                      >
                        {orderDetails.delivery_address}
                      </Typography>
                    </Stack>
                  )}

                  <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#666666",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Payment Method
                    </Typography>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#2D2D2D",
                        fontWeight: "600",
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                    >
                      {paymentMethod === "cash_on_delivery" ? "Cash on Delivery" : paymentMethod}
                    </Typography>
                  </Stack>

                  {/* <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: "#666666",
                        fontWeight: "400",
                        fontSize: "14px",
                      }}
                    >
                      Payment Status
                    </Typography>
                    <Typography
                      className="poppins-text"
                      sx={{
                        color: getStatusColor(),
                        fontWeight: "600",
                        fontSize: "14px",
                        textTransform: "capitalize",
                      }}
                    >
                      {paymentStatus === 'success' ? 'Completed' :
                        paymentStatus === 'pending' ? 'Processing' :
                          paymentStatus === 'failed' ? 'Failed' : paymentStatus}
                    </Typography>
                  </Stack> */}
                </Stack>
              </Box>
            </>
          )}

          {/* Mock Payment Indicator */}
          {searchParams.get('mock') === 'true' && (
            <Alert severity="info" sx={{ mb: 3, borderRadius: "8px", fontSize: '12px' }}>
              <Typography variant="body2" fontWeight={600}>Development Mode</Typography>
              <Typography variant="body2">
                This is a mock payment for testing purposes.
              </Typography>
            </Alert>
          )}

          {/* Payment Checking Status */}
          {checkingPayment && (
            <Alert severity="info" sx={{ mb: 3, borderRadius: "8px" }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    🔄 Verifying Payment
                  </Typography>
                  <Typography variant="body2">
                    Checking with payment provider... ({paymentCheckCount + 1}/{maxPaymentChecks})
                  </Typography>
                </Box>
                <CircularProgress size={20} />
              </Box>
            </Alert>
          )}

          {/* Action Buttons */}
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                backgroundColor: getButtonColor(),
                fontSize: "16px",
                fontFamily: "Poppins, sans-serif",
                py: 1.5,
                fontWeight: "600",
                "&:hover": {
                  backgroundColor: getButtonHoverColor(),
                },
                mb: 2
              }}
              onClick={() => {
                localStorage.removeItem('cart_items');
                navigate('/');
              }}
              startIcon={<Home />}
            >
              Go to Homepage
            </Button>

            {checkingPayment && (
              <Button
                variant="outlined"
                fullWidth
                startIcon={<Refresh />}
                onClick={() => {
                  const orderId = searchParams.get('order_id') || orderDetails?.id;
                  if (orderId) {
                    setPaymentCheckCount(0);
                    checkPaymentStatus(orderId);
                  }
                }}
                disabled={checkingPayment}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontFamily: "Poppins, sans-serif",
                  py: 1.5,
                  fontWeight: "600",
                  borderColor: getButtonColor(),
                  color: getButtonColor(),
                  "&:hover": {
                    borderColor: getButtonHoverColor(),
                    backgroundColor: "rgba(104, 0, 0, 0.04)"
                  }
                }}
              >
                Refresh Status
              </Button>
            )}

            {paymentStatus === 'failed' && (
              <Button
                variant="outlined"
                fullWidth
                startIcon={<ShoppingCart />}
                onClick={() => navigate('/checkout')}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontFamily: "Poppins, sans-serif",
                  py: 1.5,
                  fontWeight: "600",
                  borderColor: getButtonColor(),
                  color: getButtonColor(),
                  "&:hover": {
                    borderColor: getButtonHoverColor(),
                    backgroundColor: "rgba(104, 0, 0, 0.04)"
                  }
                }}
              >
                Try Again
              </Button>
            )}

            {paymentStatus === 'success' && orderDetails && (
              <Button
                variant="outlined"
                fullWidth
                startIcon={<ShoppingCart />}
                onClick={() => {
                  if (sessionStorage.getItem("user")) {
                    navigate('/profile', { state: { section: "orders" } })
                  }
                  else if (orderDetails?.unique_string) {
                    // navigate(`/order/details/${orderDetails.unique_string}`);
                    setModalOpen(true)
                  } else if (onlinePayOrder?.unique_string) {
                    navigate(`/order/details/${onlinePayOrder?.unique_string}`);
                  } else {
                    console.warn("unique_string not available yet");
                  }
                }}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontFamily: "Poppins, sans-serif",
                  py: 1.5,
                  fontWeight: "600",
                  borderColor: getButtonColor(),
                  color: getButtonColor(),
                  "&:hover": {
                    borderColor: getButtonHoverColor(),
                    backgroundColor: "rgba(104, 0, 0, 0.04)"
                  }
                }}
              >
                View Order Details
              </Button>
            )}
            {searchParams.get('status')  !== "canceled" && 
            <Button variant='outlined'
            fullWidth
            onClick={handleDownloadInvoice}
            startIcon={<Download />}
              sx={{
                mt:2,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "16px",
                fontFamily: "Poppins, sans-serif",
                py: 1.5,
                fontWeight: "600",
                borderColor: getButtonColor(),
                color: getButtonColor(),
                "&:hover": {
                  borderColor: getButtonHoverColor(),
                  backgroundColor: "rgba(104, 0, 0, 0.04)"
                }
              }}>Download Invoice</Button> }
          </Box>

          {/* Support Information */}
          <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #e0e0e0" }}>
            <Typography
              className="poppins-text"
              sx={{
                color: "#666666",
                fontWeight: "400",
                fontSize: "14px",
                textAlign: "center",
                mb: 2
              }}
            >
              Need help with your order?
            </Typography>
            <Stack direction="column" alignItems="center" spacing={1}>
              <Typography
                className="poppins-text"
                sx={{
                  color: getButtonColor(),
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {restaurantData?.email}
              </Typography>
              <Typography
                className="poppins-text"
                sx={{
                  color: getButtonColor(),
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
               {selectedOutlet?.phone}
              </Typography>
            </Stack>
          </Box>
        </Paper>


        <CommonModal modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          children={<LinkWithCopy link={`${urlUtils.getFrontendUrl()}/order/details/${orderDetails?.unique_string}`} />}
        />
      </Box>
    </>
  );
};

const VisitLinkButton = styled(Button)({
  backgroundColor: colors.primary.main,
  color: 'white',
  padding: '10px 24px',
  fontSize: '16px',
  fontWeight: 'bold',
  borderRadius: '6px',
  marginTop: '16px',
  width: '100%',
  '&:hover': {
    backgroundColor: colors.secondary.main,
  },
});


function LinkWithCopy({ link }) {
  const [currentLink, setCurrentLink] = useState(link);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentLink)
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  const handleVisitLink = () => {
    window.open(currentLink, '_blank');
  };

  return (
    <>
      <Typography id="modal-modal-title" variant="h6" component="h2" gutterBottom>
        Share Link
      </Typography>

      <TextField
        fullWidth
        value={currentLink}
        onChange={(e) => setCurrentLink(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleCopyLink}>
                <ContentCopyIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ mb: 2 }}
      />

      <VisitLinkButton
        variant="contained"
        onClick={handleVisitLink}
      >
        Visit Link
      </VisitLinkButton>
    </>
  );
}


export default PaymentResultPage;